import { useSnackbar } from 'notistack';
import React, { PropsWithChildren, useEffect } from 'react';
import { Redirect, Route } from 'react-router';
type PrivateRouteProps = {
  checks: boolean[];
  errorMessage: string;
  redirectTo: string;
  component: (props: any) => JSX.Element;
};
const PrivateRoute = ({
  component,
  checks,
  redirectTo,
  errorMessage,
  ...rest
}: PropsWithChildren<PrivateRouteProps & Route['props']>) => {
  const { enqueueSnackbar } = useSnackbar();
  let access = checks.every((a) => a === true);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!access) {
          enqueueSnackbar(errorMessage);
          return <Redirect to={redirectTo} />;
        }
        return React.createElement(component, props);
      }}
    />
  );
};

export default PrivateRoute;
